<template>
    <div class="Document container mt-5">
      <div class="bg-white p-lg-3 rounded border">
        <div class="col-12 d-none d-lg-block text-right mb-4">
          <router-link to="/dashboard" class="btn btn-danger"><i class="fa fa-close"></i></router-link>
        </div>
        
        <div class="px-3 text-right row" v-if="documents.length">
            <div class="col-md-6 col-lg-4 col-xl-3" v-for="document in documents" :key="document.id">

              <div class="card">
                <a v-if="document.baner" :href="document.baner" target="_blank" rel="noopener noreferrer">
                  <img class="card-img-top" :src="document.baner" alt="w-100" style="max-height: 240px;">
                </a>
                <div class="card-body">
                  <p class="card-text">{{ document.title }}</p>
                </div>
              </div>

            </div>
        </div>
        <div v-else class="text-danger h6">موردی یافت نشد</div>
  
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  
  export default {
    name: 'user-document',
    components: {
    },
    data() {
        return {
            documents: {},
            user: null,
        }
    },
    mounted() {
      this.$store.state.filter = false

      axios.get('/api/auth/users/me/')
        .then(response => {
        this.user = response.data
        axios.get(`document?userId=${response.data.id}`)
            .then(response => {
              if (response.data.count) {
                this.documents = response.data.results
              }
            })
            .catch(e => console.log(e.response.data.status))
            .finally(() => this.$store.state.runAnimation = false )
        })
        .catch(e => console.log(e.response.data.status))
    },
    methods: {
        
    },
  }
  </script>
  